export enum OrderStatus {
  confirmed = 'NOST',
  assigned = 'ASSG',
  completed = 'CMPL',
  cancelled = 'CNCL',
  toBeConfirmed = 'TBCL',
  onHold = 'HOLI',
  // In process
  loadingStart = 'LDNG',
  toJobSite = 'TJST',
  onJobSite = 'OJOB',
  unloading = 'UNLD',
  cmpo = 'CMPO',
}

/** Type representing the possible values of OrderStatus */
export type OrderStatusType = (typeof OrderStatus)[keyof typeof OrderStatus] | string;
